import { useEffect } from 'react';
import { useCommandPaletteIsOpen } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { isMacOs } from '@atlassian/jira-common-components-keyboard-shortcuts-dialog/src/utils.tsx';
import { useShortcuts } from '@atlassian/jira-shortcuts-dialog/src/controllers/shortcuts-service/index.tsx';

declare let JIRA: {
	Shifter?: {
		hide?: () => void;
		dialog?: {
			destroyed?: () => boolean;
		};
	};
};

export const useCloseDotMenu = () => {
	const [{ isShortcutsDialogVisible }, { setShortcutsDialogVisibility }] = useShortcuts();
	const [{ isOpen }, { open }] = useCommandPaletteIsOpen();

	useEffect(() => {
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		if (isOpen) return () => {};

		const handler = (ev: KeyboardEvent) => {
			const modifier = isMacOs() ? ev.metaKey : ev.ctrlKey;
			if (modifier && ev.key === 'k') {
				const hasMonolithDotMenu =
					typeof JIRA !== 'undefined' &&
					typeof JIRA?.Shifter?.dialog?.destroyed === 'function' &&
					!JIRA?.Shifter?.dialog?.destroyed();
				const dotOpen = isShortcutsDialogVisible || hasMonolithDotMenu;
				if (!dotOpen) return;

				if (isShortcutsDialogVisible) {
					setShortcutsDialogVisibility(false);
				}

				if (hasMonolithDotMenu) {
					JIRA.Shifter?.hide?.();
				}

				open();
			}
		};

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.addEventListener('keydown', handler);
		return () => {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.removeEventListener('keydown', handler);
		};
	}, [isOpen, isShortcutsDialogVisible, open, setShortcutsDialogVisibility]);
};
